<template>
  <AppHeader
    :is-authenticated="isAuthenticated"
    @login="login"
    @logout="logout"
  >
    <template #navigation>
      <TheBackNavigation
        v-if="backNavigation"
        :destination="backNavigation.destination"
        :label="backNavigation.label"
      />
    </template>
  </AppHeader>
  <main
    class="content"
    :class="{ 'layout-overflow': route.meta.layout == layout.overflow }"
  >
    <RouterView />
  </main>
  <Teleport to="body">
    <AppModalError
      :id="useId()"
      class="global-error-modal"
      :problem="globalProblem"
      @close="clearProblem"
    />
  </Teleport>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useId, watch } from 'vue'
import { RouterView, useRoute } from 'vue-router'

import AuthenticationService from './api/AuthenticationService'
import { auth0 } from './auth0'
import TheBackNavigation from './components/TheBackNavigation/TheBackNavigation.vue'
import AppHeader from './components/TheHeader/TheHeader.vue'
import AppModalError from './components/atomic/AppModalError/AppModalError.vue'
import { useBackNavigation } from './functions/useBackNavigation'
import { useSuperAdminStatus } from './functions/useSuperAdminStatus'
import { layout } from './router/routes'
import { useErrorStore } from './store/ErrorStore'

const { clearProblem } = useErrorStore()

const { globalProblem } = storeToRefs(useErrorStore())

const { isAuthenticated } = auth0

const route = useRoute()

const { isSuperAdmin, resolveSuperAdminStatus, forgetSuperAdminStatus } = useSuperAdminStatus()

const { backNavigation } = useBackNavigation(isSuperAdmin)

watch(
  isAuthenticated,
  (authenticated) => {
    if (authenticated) {
      resolveSuperAdminStatus()
      return
    }

    forgetSuperAdminStatus()
  },
  { immediate: true }
)

function login(): void {
  AuthenticationService.login()
}

function logout(): void {
  AuthenticationService.logout()
}
</script>

<style scoped lang="scss">
.top {
  top: 0;
  right: 0;
  left: 0;
  flex: 0 0 auto;
}

.content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;

  &:not(.layout-overflow) {
    overflow: hidden;
  }
}

.app-modal-container {
  z-index: 900000;
}
</style>
